import flatpickr from "flatpickr";
import { Spanish } from "flatpickr/dist/l10n/es.js";

class flatpickrInput {
  init() {
    flatpickr("input[type='flatpickr']", {
      animate: false,
      dateFormat: "Y-m-d",
      altFormat: "d/m/Y",
      altInput: true,
      locale: {
        ...Spanish,
        firstDayOfWeek: 0,
      },
    });

    flatpickr("input[type='flatpickrRange']", {
      animate: false,
      dateFormat: "Y-m-d",
      altFormat: "d/m/Y",
      altInput: true,
      mode: "range",
      locale: {
        ...Spanish,
        firstDayOfWeek: 0,
      },
      onClose: (x, y, instance) => {
        const $input = instance.input;

        if (instance.selectedDates.length <= 1) {
          instance.element.value = "";
          instance.altInput.value = "";
          instance.element.dispatchEvent(new Event("change"));
          instance.altInput.dispatchEvent(new Event("change"));
        } else {
          if (instance.element.getAttribute("flatpickr-auto-submit") !== null)
            instance.element.closest("form").submit();
        }
      },
    });

    flatpickr("input[type='flatpickrTime']", {
      animate: false,
      enableTime: true,
      time_24hr: true,
      dateFormat: "Y-m-d H:i",
      altFormat: "d/m/Y H:i",
      altInput: true,
      locale: {
        ...Spanish,
        firstDayOfWeek: 0,
      },
    });

    flatpickr("input[type='flatpickrPickup']", {
      minDate: new Date().fp_incr(0),
      maxDate: new Date().fp_incr(28),
      minTime: "10:00",
      maxTime: "18:00",
      animate: true,
      enableTime: true,
      time_24hr: false,
      dateFormat: "Y-m-d h:iK",
      altFormat: "Y-m-d h:iK",
      altInput: true,
      locale: {
        ...Spanish,
        firstDayOfWeek: 0,
      },
    });

    flatpickr("input[type='flatpickrclosetime']", {
      enableTime: true,
      noCalendar: true,
      dateFormat: "h:iK",
      minTime: "10:00",
      maxTime: "18:00",
      animate: true,
      time_24hr: false,
      locale: {
        ...Spanish,
        firstDayOfWeek: 0,
      },
    });
  }
}

export default flatpickrInput;
